// extracted by mini-css-extract-plugin
module.exports = {"captionStyle":"styles_captionStyle__3l72k","modalBodyWrap":"styles_modalBodyWrap__HptMZ"};